import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ProgressBarIcon = styled.div<{ margin?: number }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin-right: ${(props) => (props.margin || 0) * Screen.widthRatio}px;
  position: absolute;
  justify-content: start;
  right: ${1786 * Screen.widthRatio}px;
  top: ${303 * Screen.widthRatio}px;
  width: ${60 * Screen.widthRatio}px;
`;

export default ProgressBarIcon;
